import { colors } from "@theme/colors"

const DocumentationIcon = ({ color = colors.pureWhite, height = 18, width = 18 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9 11.8C13.9 13.7796 13.9 14.7701 13.2847 15.3847C12.6701 16 11.6796 16 9.7 16H8.3C6.3204 16 5.3299 16 4.7153 15.3847C4.1 14.7701 4.1 13.7796 4.1 11.8V9V6.2C4.1 4.2204 4.1 3.2299 4.7153 2.6153C5.3299 2 6.3204 2 8.3 2H9.7C11.6796 2 12.6701 2 13.2847 2.6153C13.9 3.2299 13.9 4.2204 13.9 6.2V9V11.8"
        stroke={color}
        strokeLinecap="round"
      />
      <path
        d="M6.9 9.69999H11.1M6.9 6.89999H11.1M6.9 12.5H9"
        stroke={color}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default DocumentationIcon
